<nz-card
  [nzTitle]="cardTitle"
  nzSize="small"
  [nzExtra]="cardExtra"
  *ngIf="source$ | async | size; else noData"
>
</nz-card>

<ng-template #cardTitle>
  <app-header-title [icon]="'table_chart'"></app-header-title>
</ng-template>
<ng-template #cardExtra>
  <button
    nz-button
    nz-tooltip
    nzTooltipPlacement="bottom"
    nzTooltipTitle="Ajouter un participant"
    [nzTooltipMouseEnterDelay]="0.5"
    (click)="onNew()"
  >
    Nouveau
  </button>
</ng-template>
<ng-template #noData>
  <app-no-result
    [icon]="'group'"
    [addtitle]="'Ajouter un participant'"
    [description]="'Aucun participant ajouté'"
    (new)="onNew()"
  ></app-no-result>
</ng-template>
